export const getCountryEmoji = (countryCode: string) => {
  if (countryCode === 'AD') return '🇦🇩';
  if (countryCode === 'AE') return '🇦🇪';
  if (countryCode === 'AF') return '🇦🇫';
  if (countryCode === 'AG') return '🇦🇬';
  if (countryCode === 'AI') return '🇦🇮';
  if (countryCode === 'AL') return '🇦🇱';
  if (countryCode === 'AM') return '🇦🇲';
  if (countryCode === 'AO') return '🇦🇴';
  if (countryCode === 'AQ') return '🇦🇶';
  if (countryCode === 'AR') return '🇦🇷';
  if (countryCode === 'AS') return '🇦🇸';
  if (countryCode === 'AT') return '🇦🇹';
  if (countryCode === 'AU') return '🇦🇺';
  if (countryCode === 'AW') return '🇦🇼';
  if (countryCode === 'AX') return '🇦🇽';
  if (countryCode === 'AZ') return '🇦🇿';
  if (countryCode === 'BA') return '🇧🇦';
  if (countryCode === 'BB') return '🇧🇧';
  if (countryCode === 'BD') return '🇧🇩';
  if (countryCode === 'BE') return '🇧🇪';
  if (countryCode === 'BF') return '🇧🇫';
  if (countryCode === 'BG') return '🇧🇬';
  if (countryCode === 'BH') return '🇧🇭';
  if (countryCode === 'BI') return '🇧🇮';
  if (countryCode === 'BJ') return '🇧🇯';
  if (countryCode === 'BL') return '🇧🇱';
  if (countryCode === 'BM') return '🇧🇲';
  if (countryCode === 'BN') return '🇧🇳';
  if (countryCode === 'BO') return '🇧🇴';
  if (countryCode === 'BQ') return '🇧🇶';
  if (countryCode === 'BR') return '🇧🇷';
  if (countryCode === 'BS') return '🇧🇸';
  if (countryCode === 'BT') return '🇧🇹';
  if (countryCode === 'BV') return '🇧🇻';
  if (countryCode === 'BW') return '🇧🇼';
  if (countryCode === 'BY') return '🇧🇾';
  if (countryCode === 'BZ') return '🇧🇿';
  if (countryCode === 'CA') return '🇨🇦';
  if (countryCode === 'CC') return '🇨🇨';
  if (countryCode === 'CD') return '🇨🇩';
  if (countryCode === 'CF') return '🇨🇫';
  if (countryCode === 'CG') return '🇨🇬';
  if (countryCode === 'CH') return '🇨🇭';
  if (countryCode === 'CI') return '🇨🇮';
  if (countryCode === 'CK') return '🇨🇰';
  if (countryCode === 'CL') return '🇨🇱';
  if (countryCode === 'CM') return '🇨🇲';
  if (countryCode === 'CN') return '🇨🇳';
  if (countryCode === 'CO') return '🇨🇴';
  if (countryCode === 'CR') return '🇨🇷';
  if (countryCode === 'CU') return '🇨🇺';
  if (countryCode === 'CV') return '🇨🇻';
  if (countryCode === 'CW') return '🇨🇼';
  if (countryCode === 'CX') return '🇨🇽';
  if (countryCode === 'CY') return '🇨🇾';
  if (countryCode === 'CZ') return '🇨🇿';
  if (countryCode === 'DE') return '🇩🇪';
  if (countryCode === 'DJ') return '🇩🇯';
  if (countryCode === 'DK') return '🇩🇰';
  if (countryCode === 'DM') return '🇩🇲';
  if (countryCode === 'DO') return '🇩🇴';
  if (countryCode === 'DZ') return '🇩🇿';
  if (countryCode === 'EC') return '🇪🇨';
  if (countryCode === 'EE') return '🇪🇪';
  if (countryCode === 'EG') return '🇪🇬';
  if (countryCode === 'EH') return '🇪🇭';
  if (countryCode === 'ER') return '🇪🇷';
  if (countryCode === 'ES') return '🇪🇸';
  if (countryCode === 'EU') return '🇪🇺';
  if (countryCode === 'ET') return '🇪🇹';
  if (countryCode === 'FI') return '🇫🇮';
  if (countryCode === 'FJ') return '🇫🇯';
  if (countryCode === 'FK') return '🇫🇰';
  if (countryCode === 'FM') return '🇫🇲';
  if (countryCode === 'FO') return '🇫🇴';
  if (countryCode === 'FR') return '🇫🇷';
  if (countryCode === 'GA') return '🇬🇦';
  if (countryCode === 'GB') return '🇬🇧';
  if (countryCode === 'GD') return '🇬🇩';
  if (countryCode === 'GE') return '🇬🇪';
  if (countryCode === 'GF') return '🇬🇫';
  if (countryCode === 'GG') return '🇬🇬';
  if (countryCode === 'GH') return '🇬🇭';
  if (countryCode === 'GI') return '🇬🇮';
  if (countryCode === 'GL') return '🇬🇱';
  if (countryCode === 'GM') return '🇬🇲';
  if (countryCode === 'GN') return '🇬🇳';
  if (countryCode === 'GP') return '🇬🇵';
  if (countryCode === 'GQ') return '🇬🇶';
  if (countryCode === 'GR') return '🇬🇷';
  if (countryCode === 'GS') return '🇬🇸';
  if (countryCode === 'GT') return '🇬🇹';
  if (countryCode === 'GU') return '🇬🇺';
  if (countryCode === 'GW') return '🇬🇼';
  if (countryCode === 'GY') return '🇬🇾';
  if (countryCode === 'HK') return '🇭🇰';
  if (countryCode === 'HM') return '🇭🇲';
  if (countryCode === 'HN') return '🇭🇳';
  if (countryCode === 'HR') return '🇭🇷';
  if (countryCode === 'HT') return '🇭🇹';
  if (countryCode === 'HU') return '🇭🇺';
  if (countryCode === 'ID') return '🇮🇩';
  if (countryCode === 'IE') return '🇮🇪';
  if (countryCode === 'IL') return '🇮🇱';
  if (countryCode === 'IM') return '🇮🇲';
  if (countryCode === 'IN') return '🇮🇳';
  if (countryCode === 'IO') return '🇮🇴';
  if (countryCode === 'IQ') return '🇮🇶';
  if (countryCode === 'IR') return '🇮🇷';
  if (countryCode === 'IS') return '🇮🇸';
  if (countryCode === 'IT') return '🇮🇹';
  if (countryCode === 'JE') return '🇯🇪';
  if (countryCode === 'JM') return '🇯🇲';
  if (countryCode === 'JO') return '🇯🇴';
  if (countryCode === 'JP') return '🇯🇵';
  if (countryCode === 'KE') return '🇰🇪';
  if (countryCode === 'KG') return '🇰🇬';
  if (countryCode === 'KH') return '🇰🇭';
  if (countryCode === 'KI') return '🇰🇮';
  if (countryCode === 'KM') return '🇰🇲';
  if (countryCode === 'KN') return '🇰🇳';
  if (countryCode === 'KP') return '🇰🇵';
  if (countryCode === 'KR') return '🇰🇷';
  if (countryCode === 'KW') return '🇰🇼';
  if (countryCode === 'KY') return '🇰🇾';
  if (countryCode === 'KZ') return '🇰🇿';
  if (countryCode === 'LA') return '🇱🇦';
  if (countryCode === 'LB') return '🇱🇧';
  if (countryCode === 'LC') return '🇱🇨';
  if (countryCode === 'LI') return '🇱🇮';
  if (countryCode === 'LK') return '🇱🇰';
  if (countryCode === 'LR') return '🇱🇷';
  if (countryCode === 'LS') return '🇱🇸';
  if (countryCode === 'LT') return '🇱🇹';
  if (countryCode === 'LU') return '🇱🇺';
  if (countryCode === 'LV') return '🇱🇻';
  if (countryCode === 'LY') return '🇱🇾';
  if (countryCode === 'MA') return '🇲🇦';
  if (countryCode === 'MC') return '🇲🇨';
  if (countryCode === 'MD') return '🇲🇩';
  if (countryCode === 'ME') return '🇲🇪';
  if (countryCode === 'MF') return '🇲🇫';
  if (countryCode === 'MG') return '🇲🇬';
  if (countryCode === 'MH') return '🇲🇭';
  if (countryCode === 'MK') return '🇲🇰';
  if (countryCode === 'ML') return '🇲🇱';
  if (countryCode === 'MM') return '🇲🇲';
  if (countryCode === 'MN') return '🇲🇳';
  if (countryCode === 'MO') return '🇲🇴';
  if (countryCode === 'MP') return '🇲🇵';
  if (countryCode === 'MQ') return '🇲🇶';
  if (countryCode === 'MR') return '🇲🇷';
  if (countryCode === 'MS') return '🇲🇸';
  if (countryCode === 'MT') return '🇲🇹';
  if (countryCode === 'MU') return '🇲🇺';
  if (countryCode === 'MV') return '🇲🇻';
  if (countryCode === 'MW') return '🇲🇼';
  if (countryCode === 'MX') return '🇲🇽';
  if (countryCode === 'MY') return '🇲🇾';
  if (countryCode === 'MZ') return '🇲🇿';
  if (countryCode === 'NA') return '🇳🇦';
  if (countryCode === 'NC') return '🇳🇨';
  if (countryCode === 'NE') return '🇳🇪';
  if (countryCode === 'NF') return '🇳🇫';
  if (countryCode === 'NG') return '🇳🇬';
  if (countryCode === 'NI') return '🇳🇮';
  if (countryCode === 'NL') return '🇳🇱';
  if (countryCode === 'NO') return '🇳🇴';
  if (countryCode === 'NP') return '🇳🇵';
  if (countryCode === 'NR') return '🇳🇷';
  if (countryCode === 'NU') return '🇳🇺';
  if (countryCode === 'NZ') return '🇳🇿';
  if (countryCode === 'OM') return '🇴🇲';
  if (countryCode === 'PA') return '🇵🇦';
  if (countryCode === 'PE') return '🇵🇪';
  if (countryCode === 'PF') return '🇵🇫';
  if (countryCode === 'PG') return '🇵🇬';
  if (countryCode === 'PH') return '🇵🇭';
  if (countryCode === 'PK') return '🇵🇰';
  if (countryCode === 'PL') return '🇵🇱';
  if (countryCode === 'PM') return '🇵🇲';
  if (countryCode === 'PN') return '🇵🇳';
  if (countryCode === 'PR') return '🇵🇷';
  if (countryCode === 'PS') return '🇵🇸';
  if (countryCode === 'PT') return '🇵🇹';
  if (countryCode === 'PW') return '🇵🇼';
  if (countryCode === 'PY') return '🇵🇾';
  if (countryCode === 'QA') return '🇶🇦';
  if (countryCode === 'RE') return '🇷🇪';
  if (countryCode === 'RO') return '🇷🇴';
  if (countryCode === 'RS') return '🇷🇸';
  if (countryCode === 'RU') return '🇷🇺';
  if (countryCode === 'RW') return '🇷🇼';
  if (countryCode === 'SA') return '🇸🇦';
  if (countryCode === 'SB') return '🇸🇧';
  if (countryCode === 'SC') return '🇸🇨';
  if (countryCode === 'SD') return '🇸🇩';
  if (countryCode === 'SE') return '🇸🇪';
  if (countryCode === 'SG') return '🇸🇬';
  if (countryCode === 'SH') return '🇸🇭';
  if (countryCode === 'SI') return '🇸🇮';
  if (countryCode === 'SJ') return '🇸🇯';
  if (countryCode === 'SK') return '🇸🇰';
  if (countryCode === 'SL') return '🇸🇱';
  if (countryCode === 'SM') return '🇸🇲';
  if (countryCode === 'SN') return '🇸🇳';
  if (countryCode === 'SO') return '🇸🇴';
  if (countryCode === 'SR') return '🇸🇷';
  if (countryCode === 'SS') return '🇸🇸';
  if (countryCode === 'ST') return '🇸🇹';
  if (countryCode === 'SV') return '🇸🇻';
  if (countryCode === 'SX') return '🇸🇽';
  if (countryCode === 'SY') return '🇸🇾';
  if (countryCode === 'SZ') return '🇸🇿';
  if (countryCode === 'TC') return '🇹🇨';
  if (countryCode === 'TD') return '🇹🇩';
  if (countryCode === 'TF') return '🇹🇫';
  if (countryCode === 'TG') return '🇹🇬';
  if (countryCode === 'TH') return '🇹🇭';
  if (countryCode === 'TJ') return '🇹🇯';
  if (countryCode === 'TK') return '🇹🇰';
  if (countryCode === 'TL') return '🇹🇱';
  if (countryCode === 'TM') return '🇹🇲';
  if (countryCode === 'TN') return '🇹🇳';
  if (countryCode === 'TO') return '🇹🇴';
  if (countryCode === 'TR') return '🇹🇷';
  if (countryCode === 'TT') return '🇹🇹';
  if (countryCode === 'TV') return '🇹🇻';
  if (countryCode === 'TW') return '🇹🇼';
  if (countryCode === 'TZ') return '🇹🇿';
  if (countryCode === 'UA') return '🇺🇦';
  if (countryCode === 'UG') return '🇺🇬';
  if (countryCode === 'UK') return '🇬🇧';
  if (countryCode === 'UM') return '🇺🇲';
  if (countryCode === 'US') return '🇺🇸';
  if (countryCode === 'UY') return '🇺🇾';
  if (countryCode === 'UZ') return '🇺🇿';
  if (countryCode === 'VA') return '🇻🇦';
  if (countryCode === 'VC') return '🇻🇨';
  if (countryCode === 'VE') return '🇻🇪';
  if (countryCode === 'VG') return '🇻🇬';
  if (countryCode === 'VI') return '🇻🇮';
  if (countryCode === 'VN') return '🇻🇳';
  if (countryCode === 'VU') return '🇻🇺';
  if (countryCode === 'WF') return '🇼🇫';
  if (countryCode === 'WS') return '🇼🇸';
  if (countryCode === 'YE') return '🇾🇪';
  if (countryCode === 'YT') return '🇾🇹';
  if (countryCode === 'ZA') return '🇿🇦';
  if (countryCode === 'ZM') return '🇿🇲';
  if (countryCode === 'ZW') return '🇿🇼';
};

export const getFrenchCountryPronoun = (countryCode: string) => {
  if (countryCode === 'AE') return 'aux';
  if (countryCode === 'BJ') return 'au';
  if (countryCode === 'BM') return 'aux';
  if (countryCode === 'BR') return 'au';
  if (countryCode === 'CA') return 'au';
  if (countryCode === 'CG') return 'au';
  if (countryCode === 'CL') return 'au';
  if (countryCode === 'DK') return 'au';
  if (countryCode === 'FJ') return 'aux';
  if (countryCode === 'GB') return 'au';
  if (countryCode === 'HK') return 'à';
  if (countryCode === 'HN') return 'au';
  if (countryCode === 'JP') return 'au';
  if (countryCode === 'KH') return 'au';
  if (countryCode === 'KM') return 'aux';
  if (countryCode === 'LU') return 'au';
  if (countryCode === 'MA') return 'au';
  if (countryCode === 'MG') return 'à';
  if (countryCode === 'ML') return 'au';
  if (countryCode === 'MM') return 'au';
  if (countryCode === 'NL') return 'aux';
  if (countryCode === 'PE') return 'au';
  if (countryCode === 'PH') return 'aux';
  if (countryCode === 'PT') return 'au';
  if (countryCode === 'RE') return 'à la';
  if (countryCode === 'SG') return 'à';
  if (countryCode === 'TD') return 'au';
  if (countryCode === 'TG') return 'au';
  if (countryCode === 'TW') return 'à';
  if (countryCode === 'US') return 'aux';
  if (countryCode === 'VN') return 'au';
  if (countryCode === 'VU') return 'au';
  if (countryCode === 'WS') return 'aux';
  if (countryCode === 'YE') return 'au';
  if (countryCode === 'YT') return 'à';
  if (countryCode === 'ZW') return 'au';

  return 'en';
};

export const getEnglishCountryPronoun = (countryCode: string) => {
  if (countryCode === 'PH') return 'the ';
  if (countryCode === 'US') return 'the ';

  return '';
};
